<template>
  <div class="custom_bg">
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          <v-card class="">
            <v-window v-model="step">
              <v-window-item :value="1" class=".d-print-none">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center align-center">
                        <v-card width="500" flat>
                          <v-autocomplete
                            v-model="model"
                            :items="items"
                            append-icon=""
                            :loading="isLoading"
                            :search-input.sync="search"
                            clearable
                            hide-details
                            :menu-props="{
                              nudgeBottom: 15 + 'px',
                              zIndex: 2,
                              rounded: 'lg',
                            }"
                            item-text="name"
                            item-value="pid"
                            placeholder="Search for a product..."
                            outlined
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-title>
                                  Search for your
                                  <strong>Product</strong>
                                </v-list-item-title>
                              </v-list-item>
                            </template>

                            <template v-slot:item="{ item }">
                              <v-list-item-avatar
                                color="indigo"
                                class="text-h5 font-weight-light white--text"
                              >
                                {{ item.name.charAt(0) }}
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title
                                  v-text="item.name"
                                ></v-list-item-title>
                                <v-list-item-subtitle
                                  v-text="item.am"
                                ></v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-action>
                                <v-btn
                                  color="primary"
                                  class="text-capitalize"
                                  small
                                  @click="add(item)"
                                >
                                  add product
                                </v-btn>
                              </v-list-item-action>
                            </template>
                          </v-autocomplete>
                        </v-card>
                      </div>
                    </v-col>
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center align-center">
                        <v-card
                          flat
                          max-height="320"
                          class="scroll px-5"
                          width="100%"
                        >
                          <v-card-title class="px-0"> ADDED ITEMS</v-card-title>
                          <v-divider></v-divider>
                          <v-card-text>
                            <v-list-item v-for="item in added" :key="item.pid">
                              <v-list-item-avatar
                                color="indigo"
                                class="
                                  text-h5
                                  font-weight-light
                                  white--text
                                  hidden-sm-and-down
                                "
                              >
                                {{ item.name.charAt(0) }}
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ item.name }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  {{ JSON.parse(item.am) }}.00
                                </v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-action>
                                <div class="d-flex align-center justify-center">
                                  <v-btn
                                    color="primary"
                                    x-small
                                    flat
                                    @click="dec(item)"
                                    >-</v-btn
                                  >
                                  <v-btn disabled x-small class="mx-2" flat>
                                    <span class="black--text text-body-2">
                                      {{ item.qty }}</span
                                    ></v-btn
                                  >
                                  <v-btn
                                    color="primary"
                                    x-small
                                    flat
                                    @click="inc(item)"
                                    >+</v-btn
                                  >
                                  <v-btn
                                    color="primary"
                                    class="ml-2"
                                    small
                                    @click="remove(item)"
                                  >
                                    remove
                                  </v-btn>
                                </div>
                              </v-list-item-action>
                            </v-list-item>
                          </v-card-text>
                        </v-card>
                      </div>
                    </v-col>
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center align-center">
                        <v-card width="600">
                          <v-card-text>
                            <v-row>
                              <v-col cols="6" class="py-0">
                                <p>Cost of product</p>
                              </v-col>
                              <v-col cols="6" class="py-0">
                                <p>{{ total }}.00</p>
                              </v-col>
                              <v-col cols="6" class="py-0">
                                <p class="mt-3">Discount</p>
                              </v-col>
                              <v-col cols="6" class="py-0">
                                <v-text-field
                                  type="number"
                                  hide-details
                                  class="pa-0"
                                  outlined
                                  v-model="discount"
                                  dense
                                ></v-text-field>
                              </v-col>
                              <v-divider></v-divider>
                              <v-col cols="6" class="py-0">
                                <p>Total payable</p>
                              </v-col>
                              <v-col cols="6" class="py-0">
                                {{ sum }}.00
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                        <div></div>
                      </div>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-card-actions class="justify-center">
                        <v-btn color="primary" width="200" @click="step++"
                          >Procced</v-btn
                        >
                      </v-card-actions>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-window-item>
              <v-window-item :value="2" class=".d-print-none">
                <v-col cols="12" md="12">
                  <v-card-text>
                    <v-form v-model="forms" ref="forms">
                      <v-col cols="12" md="12" class="py-0">
                        <div class="d-flex">
                          <v-radio-group v-model="radios" mandatory row>
                            <v-radio
                              label="New Customer"
                              value="newC"
                            ></v-radio>
                            <v-radio
                              label="Existing Customer"
                              value="existC"
                              class="mx-4"
                            ></v-radio>
                          </v-radio-group>
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                        class="py-0"
                        v-if="radios == 'newC'"
                      >
                        <span> Customer Name</span>
                        <v-text-field
                          name="name"
                          :rules="[rules.required]"
                          outlined
                          dense
                          v-model="form.cName"
                          id="id"
                        ></v-text-field>
                        <div>
                          <span> Phone Number</span>
                          <v-text-field
                       
                            outlined
                            dense
                            type="number"
                            v-model="form.phone"
                          ></v-text-field>
                        </div>
                      </v-col>

                      <v-col
                        cols="12"
                        md="6"
                        class="py-0"
                        v-if="radios == 'existC'"
                      >
                        <span> Select Customer</span>
                        <v-select
                          :items="names"
                          v-model="form.name"
                          :rules="[rules.required]"
                          outlined
                          item-value="cid"
                          item-text="name"
                          dense
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6" class="py-0">
                        <span>Amount Payable</span>
                        <v-text-field
                          outlined
                          dense
                          v-model="sum"
                          disabled
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <span>Amount Paid</span>
                        <v-text-field
                          name="name"
                          outlined
                          dense
                          :rules="[rules.required]"
                          ref="myfield"
                          :max="sum"
                          type="number"
                          oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                          v-model="form.paid"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" v-if="sum > form.paid">
                        <span>Balance Amount</span>
                        <v-text-field
                          name="name"
                          outlined
                          dense
                          type="number"
                          disabled
                          v-model="bal"
                          id="id"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" v-if="bal">
                        <span>Expected Date of payment</span>
                        <v-text-field
                          name="name"
                          outlined
                          dense
                          type="date"
                          :value="new Date()"
                          v-model="form.exDate"
                          :min="new Date().toISOString().split('T')[0]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-0">
                        <span>Payment Method</span>
                        <v-select
                          :items="method"
                          :rules="[rules.required]"
                          v-model="form.method"
                          dense
                          outlined
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-row>
                            <v-col
                              cols="12"
                              md="6"
                              class="
                                px-0
                                text-md-right text-sm-center text-xs-center
                              "
                            >
                              <v-btn
                                color="primary"
                                class="text-capitalize"
                                width="200"
                                @click="step--"
                                >Add or remove items</v-btn
                              >
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                              class="
                                px-0
                                text-md-right text-sm-center text-xs-center
                              "
                            >
                              <v-btn
                                color="primary"
                                class="text-capitalize"
                                width="200"
                                @click="comp()"
                                :loading="loaderC"
                                >complete sales</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </v-col>
                    </v-form>
                  </v-card-text>
                </v-col>
              </v-window-item>
            </v-window>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    isLoading: false,
    items: [],
    model: null,
    forms: false,
    radios: null,
    step: 1,
    search: null,
    added: [],
    
    discount: 0,
    method: ["Bank transfer/ Mobile Mobile Money", "POS", "Cash"],
    totalSum: 0,
    count: 1,
    newC: true,
    existC: false,
    form: {
      name: "",
      paid: "",
      cName: "",
      phone: "",
      payable: "",
      exDate: "",
    },
    names: [],
    compt: [],
    it: [],
    tr: "",
    loaderC: false,
    output: "receipt.pdf",
    myArr: [],
    rules: {
      length: (len) => (v) =>
        (v && v.length <= len) || `Invalid character length, required ${len}`,
      required: (v) => !!v || "This field is required",
      password: (value) =>
        (value && value.length >= 5) || "Minimum length is 5 characters",
    },
  }),

  methods: {
    add(item) {
      let unique = this.added.find((o) => o.pid === item.pid);
      if (unique) {
        alert("You can only add once, but you can increase or decrease");
      } else {
        this.added.push(item);
      }
    },
    checkBoxSelect(data) {
      console.log("data has ", data);
      if (data === "newC") {
        this.existC = false;
      } else if (data === "existC") {
        this.newC = false;
      }
    },
    inc(item) {
      let findProduct = this.added.find((o) => o.pid === item.pid);
      if (findProduct) {
        if (item.qty == JSON.parse(item.stock)) {
          console.log("........");
        } else {
          item.qty++;
          findProduct.price =
            JSON.parse(findProduct.price) + JSON.parse(item.am);
          return;
        }
      }
    },
    dec(item) {
      if (item.qty > 1) {
        let findProduct = this.added.find((o) => o.pid === item.pid);
        if (findProduct) {
          item.qty--;
          findProduct.price =
            JSON.parse(findProduct.price) - JSON.parse(item.am);
          return;
        }
      }
    },
    printr() {
      window.print();
    },

    comp() {
      if (this.$refs.forms.validate()) {
        this.loaderC = true;
        const datas = {
          name: this.form.cName,
          email: "",
          dob: new Date().toLocaleDateString(),
          phone: this.form.phone,
        };
        fetch("https://receipt.drecsoft.com/api/v1/customer/create-customer", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.currentUser}`,
          },
          body: JSON.stringify(datas),
        })
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            alert(err);
            console.log(err);
          });
        const data = {
          products: this.added,
          customer: this.form.name,
          discount: this.discount,
          amount_paid: this.form.paid,
          total_amount: this.sum,
          paymentMethod: this.form.method,
          status: "confirmed",
          store_id: this.getUser.store_id,
          expected_date: this.form.exDate,
          
        };
        fetch(
          "https://receipt.drecsoft.com/api/v1/sales/make-sales",

          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.currentUser}`,
            },
            body: JSON.stringify(data),
          }
        )
          .then((response) => response.json())
          .then((response) => {
            this.loaderC = false;

            console.log(response.data.sales);
            let docs = response.data.sales;
            this.$router.push("/receipt/" + docs.id);
          })
          .catch((err) => {
            console.log(err);
            this.loaderC = false;
          });
      }
    },

    remove(item) {
      this.added.splice(item, 1);
    },

    customers() {
      this.$store.dispatch("fetchCustomers");
    },

    arrLogic() {
      let dc = this.getCustomers;
      this.names = dc;
    },
  },

  created() {
    this.customers();
    this.arrLogic();
  },
  mounted() {
    this.checkBoxSelect();
  },
  computed: {
    ...mapGetters(["getUser", "currentUser", "getCustomers"]),
    total() {
      return this.added.reduce((sum, item) => sum + JSON.parse(item.price), 0);
    },
    sum() {
      return this.total - this.discount;
    },
    bal() {
      return this.sum - this.form.paid;
    },
    lg() {
      return this.myArr.reduce(
        (acc, item) => JSON.parse(acc) + JSON.parse(item.qty),
        0
      );
    },
  },

  watch: {
    model(val) {
      if (val != null) this.tab = 0;
      else this.tab = null;
    },
    search() {
      if (this.items.length > 0) return;
      this.isLoading = true;
      fetch(
        "https://receipt.drecsoft.com/api/v1/inventory/fetch-product?pagination=false",

        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.currentUser}`,
          },
        }
      )
        .then((response) => response.clone().json())
        .then((response) => {
          console.log(response.data.product);
          let docs = response.data.product;
          docs.forEach((item) => {
            const data = {
              name: item.name,
              price: item.price,
              pid: item.pid,
              num: 1,
              am: item.price,
              product_id: item.pid,
              amount: item.price,
              qty: 1,
              stock: item.stock,
            };
            this.items.push(data);
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<style scoped>
.custom_bg {
  background: #f6f7ff;
  height: 100%;
}
.scroll {
  overflow-y: scroll;
}
</style>
